import { joinDataTestId } from "@/constants/data-test-ids.utils";

export const slotButtonDataTestIds = {
  component: "slot-button" as const,
  button: (): string => joinDataTestId(slotButtonDataTestIds.component, "button"),
  timeLabel: (): string => joinDataTestId(slotButtonDataTestIds.component, "time-label"),
  starsRating: (): string => joinDataTestId(slotButtonDataTestIds.component, "stars-rating"),
  // Popover
  popover: (): string => joinDataTestId(slotButtonDataTestIds.component, "popover"),
  popoverTitle: (): string => joinDataTestId(slotButtonDataTestIds.component, "popover-title"),
  providerItem: (providerId: number | string): string =>
    joinDataTestId(slotButtonDataTestIds.component, "provider-item", String(providerId)),
  providerName: (providerId: number | string): string =>
    joinDataTestId(slotButtonDataTestIds.component, "provider-name", String(providerId)),
  providerStarsRating: (providerId: number | string): string =>
    joinDataTestId(slotButtonDataTestIds.component, "provider-stars-rating", String(providerId)),
};
